<!-- 宣传教育 -->
<template>
<div class='cm_duty_container'>
  <div :class="mobileClass('cm_duty_box')">
    <NewsNav  />
    <div :class="mobileClass('cm_duty_list_box')">
      <router-view :data="ele"></router-view>
    </div>
  </div>



</div>
</template>

<script>
import temp from '@/utils/importTemp.js';

export default {
components: temp,
data() {
//这里存放数据
return {
  ele:'',
  windowWidth:document.documentElement.clientWidth
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  loadItem(){
      let navList = this.$store.state.comData.navList
      for(let i=0;i<navList.length;i++){

      let re = new RegExp("^"+navList[i].path,"gi");
      if(re.test(this.$route.path)){
        this.ele = navList[i]
      }
    }
      
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  this.loadItem()
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.loadItem()
},

}
</script>
<style scoped>
.cm_duty_container{
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.cm_duty_box{
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
.cm_duty_intro{
  width: 800px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 0 20px;
  position: relative;
}
.cm_duty_intro_title{
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379D3;
}
.cm_duty_intro_title>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_duty_intro_title>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_duty_intro_content>h4{
  display: block;
  font-size: 22px;
  font-weight: 600;
  color: #000000;
  padding: 30px 0;
}
.cm_duty_intro_content>p{
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  padding: 20px 0;
}
.cm_duty_intro>img{
  position: absolute;
  bottom: 10px;
  right: 0;
}

.mobile_cm_duty_box{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.mobile_cm_duty_list_box{
  width: 100%;
}
.cm_duty_list_box{
  width: 66%;
}
</style>